// extracted by mini-css-extract-plugin
export default {"itineraryDepartureIcon":"AwsTD","departureIcon":"peC18","stepMarker":"CO11I"};